// extracted by mini-css-extract-plugin
module.exports = {"price":"_18Vao"};